import { motion } from "framer-motion";

const UK = [200, 120];
const HP = [640, 190];
const ROUTE = "M200 120 C 320 -10, 540 20, 640 190";
const HOME = "M640 190 Q 650 270 560 322";
const UKC = [["London", 228, 152], ["Leeds", 214, 104], ["Manchester", 186, 112], ["Edinburgh", 196, 58], ["Yorkshire", 236, 92], ["Dublin", 128, 116], ["Cardiff", 170, 152]];
const INC = [["Mumbai", 560, 322], ["Pune", 590, 340], ["Nashik", 572, 296]];

const bez = (t) => {
  const [p0, p1, p2, p3] = [[200, 120], [320, -10], [540, 20], [640, 190]];
  const u = 1 - t;
  return [0, 1].map((k) => u * u * u * p0[k] + 3 * u * u * t * p1[k] + 3 * u * t * t * p2[k] + t * t * t * p3[k]);
};
const EXPORT = Array.from({ length: 24 }, (_, i) => bez(1 - i / 23));

const Dot = ({ x, y, label, show, gold, delay = 0, anchor = "start" }) => (
  <motion.g initial={false} animate={{ opacity: show ? 1 : 0.18 }} transition={{ duration: 0.6, delay: show ? delay : 0 }}>
    <circle cx={x} cy={y} r={gold ? 4.5 : 3.5} fill={gold ? "#95C11F" : "#fff"} />
    <text x={anchor === "start" ? x + 8 : x - 8} y={y + 4} textAnchor={anchor} className="hidden fill-white font-mono text-[12px] sm:block">{label}</text>
  </motion.g>
);

export default function JourneyMap({ focus }) {
  const traveller =
    focus === "route" ? { cx: EXPORT.map((p) => p[0]), cy: EXPORT.map((p) => p[1]) }
      : focus === "india" ? { cx: [640, 640, 600, 560], cy: [190, 250, 300, 322] }
        : { cx: UK[0], cy: UK[1] };
  const loop = focus === "route" || focus === "india";
  return (
    <svg viewBox="40 20 700 360" className="h-full w-full" role="img" aria-label="Map of the Himachal Cider journey between the UK and India" data-testid="journey-map">
      <defs>
        <pattern id="dots" width="14" height="14" patternUnits="userSpaceOnUse"><circle cx="1.5" cy="1.5" r="1.2" fill="rgba(255,255,255,.12)" /></pattern>
      </defs>
      <rect x="40" y="20" width="700" height="360" fill="url(#dots)" />
      <path d={ROUTE} fill="none" stroke="rgba(255,255,255,.2)" strokeWidth="1.5" strokeDasharray="4 6" />
      <motion.path d={ROUTE} fill="none" stroke="#95C11F" strokeWidth="2" initial={false} animate={{ pathLength: focus === "uk" ? 0.04 : 1 }} transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }} />
      <motion.path d={HOME} fill="none" stroke="#95C11F" strokeWidth="2" initial={false} animate={{ pathLength: focus === "india" ? 1 : 0, opacity: focus === "india" ? 1 : 0 }} transition={{ duration: 1.2 }} />
      {UKC.map(([n, x, y], i) => <Dot key={n} x={x} y={y} label={n} show={focus === "ukcities" || (focus === "uk" && n === "Yorkshire")} delay={i * 0.08} anchor={x < 200 ? "end" : "start"} />)}
      {INC.map(([n, x, y], i) => <Dot key={n} x={x} y={y} label={n} show={focus === "india"} gold delay={i * 0.12} anchor="end" />)}
      <g>
        <circle cx={UK[0]} cy={UK[1]} r="9" fill="none" stroke="#fff" strokeOpacity=".5" />
        <text x={UK[0] + 20} y={UK[1] + 70} textAnchor="middle" className="fill-white font-display text-[22px] italic">United Kingdom</text>
      </g>
      <g>
        <circle cx={HP[0]} cy={HP[1]} r="9" fill="none" stroke="#95C11F" />
        <text x={HP[0] + 14} y={HP[1] + 6} className="fill-gold font-display text-[22px] italic">Himachal</text>
      </g>
      <motion.circle
        r="7"
        fill="#95C11F"
        initial={false}
        animate={traveller}
        transition={loop ? { duration: 3.2, repeat: Infinity, ease: "easeInOut", repeatDelay: 0.4 } : { duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
        style={{ filter: "drop-shadow(0 0 10px rgba(149,193,31,.9))" }}
      />
    </svg>
  );
}
